import { post } from "../fetch";

export function addRole() {
  document.addEventListener("DOMContentLoaded", () => {
    const button = document.getElementById("discord-add-role-button");
    if (!button) {
      return;
    }
    button.addEventListener("click", async () => {
      const spinner = document.getElementById("discord-member-role__spinner");
      spinner && (spinner.style.display = "inline-flex");
      await addRoleAjax();
      spinner && (spinner.style.display = "none");
    });
  });
}

async function addRoleAjax() {
  // @ts-ignore
  const ajaxUrl = window?.ystdssScriptsData?.ajaxUrl;
  try {
    const response = await post(ajaxUrl, { action: "add_role" });
    const data = await response.json();
    if (response.ok) {
      showMessage(data.message);
    } else {
      showMessage(data.message, "error");
    }
  } catch (e) {
    // @ts-ignore
    console.error(e.message);
  }
}

function showMessage(message: string, type = "success") {
  const element = document.getElementById(`discord-add-role-message--${type}`);
  if (element) {
    element.style.display = "block";
    element.style.opacity = "1";
    element.innerText = message;

    setTimeout(() => {
      element.style.opacity = "0";
    }, 2000);
    setTimeout(() => {
      element.style.display = "none";
    }, 3000);
  }
}
